import React, { Component } from 'react';
import {connect} from 'react-redux'; 
import Error from './Error';
import {_} from '../../locale';
import {login} from '../../actions/auth';
import {CONFIG, COUNTRY_CODE} from '../../constants';
import { Link } from 'react-router-dom';
import TagManager from 'react-gtm-module';
// import Select from 'react-select'
// import countryList from 'react-select-country-list'

const tagManagerArgs = {
  gtmId: 'AW-466144154'
}

class LoginForm extends Component {
  constructor(props){
    super(props);
    this.state = {
      pwdShow: 0,
      errors: {},
      countryCode: '61',
      firstCls: 'col-4 pr-2',
      secondCls: 'col-8 pl-0',
      showConCode: true
    };
    this.showPasswordVisibility = this.showPasswordVisibility.bind(this);
    this.setCountryCode = this.setCountryCode.bind(this);
    this.bindSlider = this.bindSlider.bind(this);
    this.checkLoginType = this.checkLoginType.bind(this);
    // this.chkCountryCode = this.chkCountryCode.bind(this);
  }

  checkLoginType(e){
    let str = e.target.value;
    if(/^[^a-zA-Z]*$/.test(str)){
      console.log('MN');
      this.setState({
        firstCls: 'col-4 pr-2',
        secondCls: 'col-8 pl-0',
        showConCode: true

      })
    } else {
      this.setState({
        firstCls: '',
        secondCls: 'col-12 w100',
        showConCode: false
      })
      console.log('email');
    }
  }

  componentDidMount(){
    window.addEventListener('load', this.bindSlider);
    if(document.readyState === "complete" || document.readyState === "interactive"){
        this.bindSlider();
    }
  }

  componentDidUpdate(){
    window.addEventListener('load', this.bindSlider);
    if(document.readyState === "complete" || document.readyState === "interactive"){
        try{
          this.bindSlider();
        }catch(error){
          console.log('error', error);
        }
    }
  }

  bindSlider(){
    if(!COUNTRY_CODE.length)
      return;
    const $ = window.$$;
    $('.selectpicker').selectpicker();
  }

  setCountryCode(event){
    let conCode = event.target.value;
    this.setState({
      countryCode: conCode
    })
  }

  submit(e){
    e.preventDefault();
    const {countryCode, showConCode} = this.state;
    const {phoneNumber, password} = this.refs;
    var errors = {};
    let records = {};

    if ((!phoneNumber.value || phoneNumber.value.trim() === '')) {
      errors = {...errors, phoneNumber: 'Enter email/mobile number'};
    } else if (!password.value || password.value.trim() === '') {
      errors = {...errors, password: 'Enter password'};
    }

    this.setState({
      errors
    })

    if(Object.keys(errors).length){
      return;
    }

    TagManager.initialize(tagManagerArgs);


    if(showConCode){
      records = {countryCode, phoneNumber: phoneNumber.value, password: password.value};
    } else {
      records = {phoneNumber: phoneNumber.value, password: password.value};
    }


    this.props.login(this, records).then(response => {
     
    }).catch(error => {
      this.setState({
        processing: false
      })
    })
  }

  showPasswordVisibility(){
    console.log('======a==a==', this.state.pwdShow);
    this.setState({
      pwdShow: !this.state.pwdShow
    })
  }

  render() {

      

      const {processing, pwdShow, errors, countryCode, firstCls, secondCls, showConCode } = this.state;
      let countries = COUNTRY_CODE;
      return (
        <div className="form-main-wrpr frgt-pswd">
           <span className='bg-effect'></span>
            <form onSubmit={this.submit.bind(this)}>
              <div className="white-bg padding40 border-radius-12 mx-auto" style={{maxWidth:"450px"}}>
                <div className="form-heading-grp marginB32">
                  <h4 className="h4 fw700">Welcome to <span className="text-primary">KKBits</span></h4>
                  <p>We make it easy for everyone to send money instantly anywhere, anytime.</p>
                </div>
                <div className="form-group">
                  <label className= "text-grey-1">Mobile Number / Email</label>
                  <div className="row">
                    {
                      showConCode
                      ?
                      <div className={firstCls}>
                        <select value={countryCode} className="selectpicker cstm_select" data-show-subtext="true" data-live-search="true" name="countryCode" onChange={this.setCountryCode}>
                          {
                            countries && countries.length > 0 && countries.map((obj, index) => (
                                <option value={obj.phonecode} key={index}>{'+'+obj.phonecode} {"("+obj.sortname+")"}</option>
                            ))
                          }
                        </select>
                      </div>
                      :
                      null
                    }
                    
                    <div className={secondCls}>
                      <input placeholder='Enter mobile number' ref="phoneNumber" type="text" className={typeof errors.phoneNumber !== 'undefined' ? "form-control error" : "form-control"} onChange={this.checkLoginType} autocomplete="off" />
                      {typeof errors.phoneNumber !== 'undefined' && <Error text={errors.phoneNumber} />}
                    </div>
                  </div>
                </div>
                <div className="form-group position-relative">
                  <div className="row">
                    <div className="col-4">
                      <label className= "text-grey-1">Password</label>
                    </div>
                    <div className="col-8 text-right">
                      <Link className="fs12 text-primary" to="/forgot-password">Forgot password?</Link> 
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <input placeholder='Enter your password' ref="password" type={ pwdShow ? "text" : "password"} className="form-control w-100 pswd-field" maxLength="20"  />
                      <div className="password-view" onClick={this.showPasswordVisibility}> <img src={ pwdShow ? "/assets/images/password-view.svg" : "/assets/images/eye-hide.svg"} alt="img" className={pwdShow ? 'show-icon' : 'hide-icon'} /> </div>
                      {typeof errors.password !== 'undefined' && <Error text={errors.password} />}
                    </div>
                  </div>
                </div>
                <div className="btn-grp text-center">
                  <button disabled={processing} className="btn btn-primary w-100">{_('Login')}</button>
                </div>
                <div className="other-info text-center">
                  <p>Don’t have account? <Link to="/sign-up" className="fw700">Sign up</Link></p>
                </div>
              </div>
            </form>
        </div>
      );
  }
}

export default connect(null, {login})(LoginForm);